import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { CommissionType } from 'src/entities/commission-account/CommissionEntry';
import { action } from 'src/store/actions';

/*  Commission Account Stats  */
export const FETCH_COMMISSION_STATS = 'FETCH_COMMISSION_STATS';
export const REQUEST_COMMISSION_STATS = 'REQUEST_COMMISSION_STATS';
export const SUCCESS_COMMISSION_STATS = 'SUCCESS_COMMISSION_STATS';
export const FAILURE_COMMISSION_STATS = 'FAILURE_COMMISSION_STATS';

export const fetchCommissionStats = (
    selectedYear: number,
    compareYear: number,
    commissionType: CommissionType,
    ignoreEligibility: boolean = false
) => action(FETCH_COMMISSION_STATS, { selectedYear, compareYear, commissionType, ignoreEligibility });
/** R65 item 8c: Mein Bereich's commission statistics from ordering (the Credit statistics stay on userservice). */
export const FETCH_MY_COMMISSION_STATS = 'FETCH_MY_COMMISSION_STATS';
export const fetchMyCommissionStats = (selectedYear: number, compareYear: number) =>
    action(FETCH_MY_COMMISSION_STATS, { selectedYear, compareYear });
export const requestCommissionStats = () => action(REQUEST_COMMISSION_STATS);
export const requestCommissionStatsSuccess = (response: any) => action(SUCCESS_COMMISSION_STATS, { response });
export const requestCommissionStatsFailure = (error: any) => action(FAILURE_COMMISSION_STATS, { error });

/* Commission Account Entries */
export const FETCH_COMMISSION_ENTRIES = 'FETCH_COMMISSION_ENTRIES';
export const REQUEST_COMMISSION_ENTRIES = 'REQUEST_COMMISSION_ENTRIES';
export const SUCCESS_COMMISSION_ENTRIES = 'SUCCESS_COMMISSION_ENTRIES';
export const FAILURE_COMMISSION_ENTRIES = 'FAILURE_COMMISSION_ENTRIES';

export const fetchCommissionEntries = (
    year: number | null,
    month: number | null,
    commissionType: CommissionType,
    ignoreEligibility: boolean = false,
    pageable?: PageableQueryParams
) =>
    action(FETCH_COMMISSION_ENTRIES, {
        year,
        month,
        commissionType,
        ignoreEligibility,
        pageable,
    });
export const requestCommissionEntries = () => action(REQUEST_COMMISSION_ENTRIES);
export const requestCommissionEntriesSuccess = (response: any) => action(SUCCESS_COMMISSION_ENTRIES, { response });
export const requestCommissionEntriesFailure = (error: any) => action(FAILURE_COMMISSION_ENTRIES, { error });
